//#region src/nodey-graph-templates/mesh-gen.ts
var e = (e) => ({
	options: {},
	connections: [{
		inputNodeId: "94d1e4cb-10f0-40ff-81f4-c1fd4dd6947a",
		outputNodeId: "302ccfbc-b56b-4077-84a2-27b33abb4497",
		inputName: "prompt",
		outputName: "text_data",
		isEnabled: !0,
		type: "string"
	}, {
		inputNodeId: "05c5427e-d5c8-4aa8-9c61-ffa2528b4b98",
		outputNodeId: "94d1e4cb-10f0-40ff-81f4-c1fd4dd6947a",
		inputName: "model_data",
		outputName: "generated_model",
		isEnabled: !0,
		type: "model-3d"
	}],
	frames: [],
	nodes: {
		"302ccfbc-b56b-4077-84a2-27b33abb4497": {
			id: "302ccfbc-b56b-4077-84a2-27b33abb4497",
			type: "const-string",
			customName: "Text",
			position: {
				x: 12.42308841942649,
				y: 136.73043583663076
			},
			collapsed: !1,
			isEnabled: !0,
			io: {
				inputs: {},
				outputs: {}
			}
		},
		"94d1e4cb-10f0-40ff-81f4-c1fd4dd6947a": {
			id: "94d1e4cb-10f0-40ff-81f4-c1fd4dd6947a",
			type: "gen-meshy-text",
			customName: "Meshy Text to 3D",
			position: {
				x: 335.62979490963284,
				y: 166.20708514713945
			},
			collapsed: !1,
			isEnabled: !0,
			io: {
				inputs: {},
				outputs: {}
			}
		},
		"05c5427e-d5c8-4aa8-9c61-ffa2528b4b98": {
			id: "05c5427e-d5c8-4aa8-9c61-ffa2528b4b98",
			type: "io-model-asset-save",
			customName: "Save OKO Model Asset",
			position: {
				x: 658.4082927589286,
				y: 207.44762780371505
			},
			collapsed: !1,
			isEnabled: !0,
			io: {
				inputs: {},
				outputs: {}
			}
		}
	}
});
//#endregion
export { e as meshGenNodeyTemplate };
